import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const disordersOfTheKidney: AnswerPathTreeNode = {
  path: 'disordersOfTheKidney',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredDisordersOfTheKidneyDetails }],
};
